<style lang="scss">
.module3 {
  .slide-12 {
    background-image: url("../../../assets/module3/slide12/background-01.jpg");
    background-size: cover;
    background-position: center;
    padding-top: 80px;
    padding-left: 210px;
    height: calc(100% - 80px);

    .timmmy {
      position: absolute;
      top: 0;
      left: 0;
    }

    .heading1 {
      transform: rotate(-3deg);
    }
    h1 {
      span {
        color: #edad0a;
        font-size: 100px;
      }
      color: #edad0a;
      font-size: 65px;
      &:nth-child(2) {
        transform: translateX(-130px);
      }
      &:nth-child(1) {
        transform: translateX(-65px);
      }
    }

    p {
      color: #ffffff;
      margin-top: 50px;
      max-width: 492px;
    }

    .heading2 {
      color: #ffffff;
      padding-top: 55px;
      font-size: 110px;
    }

    .heading3 {
      margin-left: 50px;
    }

    .heading4 {
      margin-left: 100px;
    }

    .heading5 {
      font-size: 80px;
      transform: rotate(-5deg);
      margin-top: 50px;
    }

    .number {
      left: 795px;
      position: absolute;
      h1 {
        font-size: 180px;
        color: #e30613;
      }
    }

    .heading-button {
      margin-top: 550px;
      margin-left: 280px;
      width: 225px;
      flex-shrink: 0;
      img {
        transform: scale(1.6);
        padding-top: 30px;
      }
    }
    .block-text {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
    }
  }
}
</style>

<template>
  <div class="slide-12">
    <transition name="fadeUp" appear>
      <img
        class="chars delay-1"
        v-show="slideIndex == 11"
        src="@/assets/module3/slide12/timmy-01.png"
      />
    </transition>
    <transition name="fadeLeft" appear>
      <div class="delay-1" v-show="slideIndex == 11">
        <div class="heading1">
          <h1 v-html="$t('module3.slide12.heading1')"></h1>
          <h1 v-html="$t('module3.slide12.heading2')"></h1>
          <h1 v-html="$t('module3.slide12.heading3')"></h1>
        </div>
      </div>
    </transition>
    <transition name="fadeUp" appear>
      <div class="delay-2" v-show="slideIndex == 11">
        <h1 class="heading2" v-html="$t('module3.slide12.heading4')"></h1>
      </div>
    </transition>
    <transition name="scale" appear>
      <div class="delay-3 number" v-show="slideIndex == 11">
        <h1 v-html="$t('module3.slide12.number')"></h1>
      </div>
    </transition>
    <transition name="fadeUp" appear>
      <div v-show="slideIndex == 11" class="delay-4">
        <p>{{ $t("module3.slide12.copy1") }}</p>
      </div>
    </transition>

    <transition name="fadeUp" appear>
      <div v-show="slideIndex == 11" class="delay-5">
        <p>{{ $t("module3.slide12.copy2") }}</p>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
